<template>
    <div class="avatar-wrapper">
        <!-- <div class="cropper-dialog" v-show="isCropperOpen"> -->
        <div class="cropper-dialog" v-show="isCropperOpen && cropper.crop">
            <div class="pos">
                <div class="body">
                    <div class="header">
                        <span class="title">Редактирование изображения</span>
                        <div class="close" icon @click="isCropperOpen = false">
                            <font-awesome-icon
                                class="close-icon icon"
                                icon="times"
                            ></font-awesome-icon>
                        </div>
                    </div>
                    <Cropper
                        style="margin: 10px"
                        ref="cropper"
                        :aspectRatio="cropper.aspectRatio"
                        :file="fileToUpload"
                    />
                    <div class="controls">
                        <btn class="btn" outline @click="isCropperOpen = false"
                            >Сбросить</btn
                        >
                        <btn class="btn" @click="crop">Сохранить</btn>
                    </div>
                </div>
            </div>
        </div>
        <div class="avatar-name" :data-voicetext="label">{{ label }}</div>

        <div
            v-if="isAvatar"
            class="avatar contains_background_image"
            :style="`background-image: url(${url})`"
        >
            <input
                type="file"
                ref="file"
                @change="handleImage"
                accept=".jpg, .jpeg, .png"
            />
        </div>

        <div v-else class="avatar">
            <Wait class="wait-avatar" />
        </div>
    </div>
</template>

<script>
import { post } from '../../../tools/http';

import Wait from '../../../components/Wait';
import Cropper from '../Cropper';
import Btn from '../Button';

import { mapGetters } from 'vuex';
import { avatarBinder, getImgUrl } from '../../../tools/uploader';

const getters = ['user_img_stub'];

export default {
    name: 'imgModel',
    components: {
        Wait,
        Btn,
        Cropper,
    },
    props: {
        label: String,
        data: [Object, String],
        type: String,
        cropper: {
            type: Object,
            default() {
                return {
                    crop: false,
                    aspectRatio: 'free',
                };
            },
        },
    },
    data() {
        return {
            fileToUpload: null,
            fileName: '',
            isCropperOpen: false,
        };
    },
    computed: {
        ...mapGetters(getters),

        isAvatar() {
            return typeof this.data == 'string';
        },
        url() {
            return this.isAvatar ? this.data : null;
        },
    },
    model: {
        prop: 'data',
        event: 'change',
    },
    methods: {
        handleImage(e) {
            this.fileToUpload = e.target.files[0];
            if (this.cropper.crop) {
                this.isCropperOpen = true;
            } else {
                this.loadAvatar();
            }
        },
        async crop() {
            this.fileToUpload = await this.$refs.cropper.crop();
            this.loadAvatar();
            this.isCropperOpen = false;
        },
        async loadAvatar() {
            if (!this.fileToUpload) return;

            const response = await post('profile', 'file/upload', {
                file: this.fileToUpload,
                isPublic: true,
            });

            if (response == null) return;

            this.$emit('change', null);

            const id = await avatarBinder(
                { fileId: response.file.id },
                this.type
            );

            if (!id) return;

            const fileUrl = response.file.url;
            const url = await getImgUrl(fileUrl, this.user_img_stub);

            this.$emit('change', url);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';

.avatar-wrapper {
    display: flex;
    flex-direction: column;

    .cropper-dialog {
        position: fixed;
        z-index: 9999;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba($color: #000000, $alpha: 0.5);
        .pos {
            position: absolute;
            left: 50%;
        }
        .body {
            position: relative;
            top: rem(120);
            left: -50%;
            width: rem(1024);
            display: flex;
            flex-direction: column;
            align-items: center;
            align-content: center;
            background-color: white;
            border-radius: rem(4);
            padding: 40px 0;
            .title {
                width: 100%;
                font-size: urem(18);
                text-align: center;
            }
            .close {
                position: absolute;
                top: 12px;
                right: 12px;
                width: urem(14);
                height: urem(14);
                cursor: pointer;
            }
            .controls {
                display: flex;
                .btn:first-child {
                    margin-right: rem(32);
                    color: #98a0a9;
                    border-color: #98a0a9;
                }
            }
        }
    }

    .main-avatar {
        display: flex;
        flex-direction: column;
        margin-bottom: 1.5rem;
    }

    .official-avatar {
        display: flex;
        flex-direction: column;
    }

    .avatar-name {
        font-size: 0.6rem;
        color: #98a0a9;
        font-weight: 600;
        margin-bottom: 0.25rem;
    }

    .avatar {
        width: 8.5rem;
        height: 8.5rem;
        border-radius: 0.25rem;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;

        input {
            width: 100%;
            height: 100%;
            cursor: pointer;
            opacity: 0;
        }
    }

    .wait-avatar {
        width: 100%;
        height: 100%;
    }
}

@import '../../../styles/variables';
@media (max-width: $vm) {
    .avatar-wrapper {
        .avatar {
            width: mrem(159);
            height: mrem(159);
        }

        .avatar-name {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: mrem(12);
            margin-bottom: mrem(20);
        }

        .cropper-dialog {
            .body {
                width: 100vw;

                .controls {
                    width: 100%;
                    justify-content: center;
                    .btn {
                        width: auto;
                        padding-left: mrem(15);
                        padding-right: mrem(15);
                        font-size: urem(14);
                    }
                }
            }
            .close-icon {
                width: urem(14);
                height: urem(14);
            }
        }
    }
}
</style>
